'use strict';

var CID = require('cids');

var multiaddr = require('multiaddr');

var multibase = require('multibase');

var multihash = require('multihashes');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

module.exports = function () {
  return {
    Buffer: Buffer,
    CID: CID,
    multiaddr: multiaddr,
    multibase: multibase,
    multihash: multihash,
    PeerId: PeerId,
    PeerInfo: PeerInfo
  };
};